import { ratingBreakdown } from "@/mocks/admin/feedback";

export default function RatingSummary() {
  const total = ratingBreakdown.reduce((s, r) => s + r.count, 0);
  const weighted = ratingBreakdown.reduce((s, r) => s + r.count * r.stars, 0);
  const avg = (weighted / total).toFixed(1);

  return (
    <div className="bg-white border border-ink-100 rounded-lg p-5">
      <h3 className="font-display text-base font-bold text-ink-900 mb-4">Rating Summary</h3>

      <div className="flex items-center gap-4 mb-5 pb-5 border-b border-ink-100">
        <div className="text-center">
          <div className="font-display text-4xl font-bold text-ink-900 leading-none">{avg}</div>
          <div className="flex items-center gap-0.5 justify-center mt-1.5">
            {[1, 2, 3, 4, 5].map((s) => (
              <i
                key={s}
                className={`ri-star-fill text-sm ${
                  s <= Math.round(parseFloat(avg)) ? "text-amber-500" : "text-ink-200"
                }`}
              ></i>
            ))}
          </div>
          <div className="text-[10px] text-ink-500 mt-1">{total} reviews</div>
        </div>

        <div className="flex-1 space-y-1.5">
          {ratingBreakdown.map((r) => (
            <div key={r.stars} className="flex items-center gap-2 text-[11px]">
              <span className="w-6 font-bold text-ink-700">{r.stars}★</span>
              <div className="flex-1 h-1.5 rounded-full bg-cream-100 overflow-hidden">
                <div
                  className={`h-full rounded-full ${
                    r.stars >= 4 ? "bg-emerald-500" : r.stars === 3 ? "bg-amber-500" : "bg-rose-500"
                  }`}
                  style={{ width: `${r.pct}%` }}
                ></div>
              </div>
              <span className="w-8 text-right font-semibold text-ink-700 tabular-nums">
                {r.count}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="text-[10px] font-bold uppercase tracking-wider text-ink-400 mb-3">
        Where reviews come from
      </div>
      <ul className="space-y-2 text-sm">
        {[
          { name: "Google Reviews", count: 78, icon: "ri-google-fill", color: "text-amber-600" },
          { name: "Email Survey", count: 54, icon: "ri-mail-line", color: "text-indigo-600" },
          { name: "Yelp", count: 32, icon: "ri-star-line", color: "text-rose-600" },
          { name: "SMS Survey", count: 18, icon: "ri-message-2-line", color: "text-emerald-600" },
        ].map((src) => (
          <li key={src.name} className="flex items-center gap-2.5">
            <span className={`w-7 h-7 flex items-center justify-center rounded-md bg-cream-100 ${src.color}`}>
              <i className={`${src.icon} text-sm`}></i>
            </span>
            <span className="flex-1 text-ink-700">{src.name}</span>
            <span className="text-sm font-bold text-ink-900 tabular-nums">{src.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}